// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2auus","header":"Messages_header__1gL0d"};